module.exports = __webpack_public_path__ + "static/media/addison-groove-project-bonnaroo.e8217ab2.jpg";